<template>
  <div class="checkbox" :class="checkboxModifiers">
    <label :for="name">
      <input
        type="checkbox"
        :name="name"
        :id="name"
        :checked="modelValue || undefined"
        :disabled="disabled"
        @change="onChange"
      />
      <div class="checkbox__tick" :class="classIsChecked"></div>
      <div class="checkbox__label">{{ label }}</div></label
    >
  </div>
</template>

<script src="./checkbox.js"></script>
<style src="./checkbox.scss" lang="scss"></style>
